
export default {
	methods: {
		async checkApplicationVersion(responseApplicationVersion) {
			let cacheVersion
			await this.getCacheVersion().then(version => {
				cacheVersion = `v${version}`
			})
			
			// App Version from Api is different with the Cache Version
			if(responseApplicationVersion !== cacheVersion) {
				// Reload to detect new Service Worker
				if(!JSON.parse(localStorage.getItem('pwa-version-reload'))) {
					// Add flag in localStorage to avoid refresh loop
					localStorage.setItem('pwa-version-reload', JSON.stringify(true))
					window.location.reload()
				}
			}
		},
		getCacheVersion() {
			return window.caches.keys().then(caches => {
				const cacheGaia = caches.find(cache => cache.includes('gaia-pwa'))
				return cacheGaia.split('-v')[1]
			})
		}
	}
}
